import { render } from "./Tutorial-One-Step.vue?vue&type=template&id=4084e78a"
import script from "./Tutorial-One-Step.vue?vue&type=script&lang=js"
export * from "./Tutorial-One-Step.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__